import type React from 'react';

type ComponentType<P = any, R = any> =
  | React.ComponentClass<P>
  | React.FunctionComponent<P>
  | React.ForwardRefExoticComponent<P & React.RefAttributes<R>>;

const withDisplayName = <T extends ComponentType>(component: T, displayName: string): T => {
  return Object.defineProperty(component, 'displayName', {
    value: displayName
  });
};

export default withDisplayName;
